import React, { useState, useEffect } from "react";

import { generateTextReportPDF } from "../../../components/pdf/GenerateTextReportPDF";
import ReportsHeader from "../../../components/HecoReports/ReportHeader/ReportHeader";
import ReportContent from "../../../components/HecoReports/TextReport/ReportContent/ReportContent";
import TextReportHeader from "../../../components/HecoReports/TextReport/Utils/TextReportHeader.jsx";

import "./TextReport.css";
import { Navigate } from "react-router-dom";

function TextReport() {
  const companyName = localStorage.getItem("companyName");
  const timestamp = localStorage.getItem("timestamp");
  const textReportHeader = TextReportHeader();

  return (
    <>
     {/* Generate report if there is a timestamp, otherwise redirects to input form */}
      {timestamp ? (
        <>
          <ReportsHeader defaultType={"Text Report"} />
          <div className="report-body">
            <ReportContent
              companyName={companyName}
              timestamp={timestamp}
              generatePDF={generateTextReportPDF}
              textReportHeader={textReportHeader}
            />
          </div>
        </>
      ) : (
        <Navigate to="/inputform" />
      )}
    </>
  );
}

export default TextReport;
